import OneRepMaxChartDataActionsContext from "components/charting/contexts/OneRepMaxChartDataActionsContext";
import useDefinedContext from "hooks/useDefinedContext";

function useOneRepMaxChartDataActions() {
  return useDefinedContext(OneRepMaxChartDataActionsContext);
}

export default useOneRepMaxChartDataActions;
